import React, { useState } from "react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";
import api from "../../lib/api";
import { errMsg } from "./ui";

export default function DeleteButton({ endpoint, name, note, onDone, testId }) {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.delete(endpoint);
      toast.success(`"${name}" dihapus`);
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); setOpen(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <button data-testid={testId} className="text-[#F06464] hover:underline text-xs ml-4">Hapus</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#202127] border-[#35353B] text-[#F5F3ED]">
        <AlertDialogHeader>
          <AlertDialogTitle style={{ fontFamily: "'Playfair Display', serif" }}>Hapus "{name}"?</AlertDialogTitle>
          <AlertDialogDescription className="text-[#A8A8AD]">
            Data akan hilang dari Panel Kelola dan marketplace. Riwayat pesanan lama tetap tersimpan. {note}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`} className="bg-transparent border-[#35353B] text-[#F5F3ED] hover:bg-[#191A1F] hover:text-[#F5F3ED]">Batal</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={confirm} disabled={busy} className="bg-[#F06464] text-white hover:bg-[#e04f4f]">
            {busy ? "Menghapus..." : "Ya, hapus"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
